import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'TreesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trees",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 5l3 3l-2 1l4 4l-3 1l4 4h-9"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 21l0 -3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 13l-2 -2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 12l2 -2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 21v-13"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5.824 16a3 3 0 0 1 -2.743 -3.69a3 3 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a3 3 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
    }, null), _createTextVNode(" ")]);
  }
};